import React from "react";
import { Routes, Route, Navigate, BrowserRouter } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./lib/auth-context";
import { TasksProvider } from "./lib/tasks-context";
import { AgentsProvider } from "./lib/agents-context";
import { NotesProvider } from "./lib/notes-context";
import AgentsDialog from "./components/AgentsDialog";
import AuthPage from "./pages/AuthPage";
import ChatPage from "./pages/ChatPage";
import SettingsPage from "./pages/SettingsPage";
import NotesPage from "./pages/NotesPage";
import BotsPage from "./pages/BotsPage";
import BotGroupPage from "./pages/BotGroupPage";
import BotRunPage from "./pages/BotRunPage";
import AdminApp from "./admin/AdminApp";
import "./App.css";

function RequireAuth({ children }) {
    const { user, loading } = useAuth();
    if (loading) {
        return (
            <div className="h-screen w-screen flex items-center justify-center bg-background">
                <div className="font-mono text-xs text-muted-foreground tracking-widest uppercase animate-pulse">
                    carregando_sessao...
                </div>
            </div>
        );
    }
    if (!user) return <Navigate to="/login" replace />;
    return children;
}

function PublicOnly({ children }) {
    const { user, loading } = useAuth();
    if (loading) return null;
    if (user) return <Navigate to="/chat" replace />;
    return children;
}

function App() {
    return (
        <div className="App grain">
            <BrowserRouter>
                <AuthProvider>
                    <TasksProvider>
                        <AgentsProvider>
                        <NotesProvider>
                        <Routes>
                            <Route path="/" element={<Navigate to="/chat" replace />} />
                            <Route path="/login" element={<PublicOnly><AuthPage /></PublicOnly>} />
                            <Route path="/chat" element={<RequireAuth><ChatPage /></RequireAuth>} />
                            <Route path="/chat/:taskId" element={<RequireAuth><ChatPage /></RequireAuth>} />
                            <Route path="/notas" element={<RequireAuth><NotesPage /></RequireAuth>} />
                            <Route path="/bots" element={<RequireAuth><BotsPage /></RequireAuth>} />
                            <Route path="/bots/g/:groupId" element={<RequireAuth><BotGroupPage /></RequireAuth>} />
                            <Route path="/bots/run/:runId" element={<RequireAuth><BotRunPage /></RequireAuth>} />
                            <Route path="/configuracoes" element={<RequireAuth><SettingsPage /></RequireAuth>} />
                            <Route path="/admin/*" element={<AdminApp />} />
                            <Route path="*" element={<Navigate to="/chat" replace />} />
                        </Routes>
                        <AgentsDialog />
                        </NotesProvider>
                        <Toaster
                            theme="dark"
                            position="top-center"
                            toastOptions={{
                                style: {
                                    background: "#161616",
                                    color: "#F0F0F0",
                                    border: "1px solid #222",
                                    borderRadius: "4px",
                                    fontFamily: "'IBM Plex Sans', sans-serif",
                                },
                            }}
                        />
                        </AgentsProvider>
                    </TasksProvider>
                </AuthProvider>
            </BrowserRouter>
        </div>
    );
}

export default App;
